import React from "react";
import { Link } from "react-router-dom";
import { FaMapMarkerAlt, FaPhone, FaEnvelope } from "react-icons/fa";
import "./ReachUs.css";

const INDIA_MAP_EMBED =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.46512891372!2d78.40001199999999!3d17.437438!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9104e126e10d%3A0x785ca2c67313cde8!2sQHub%20-%20Coworking%20Space%20%7C%20Business%20Center%20%7C%20Conference%20Rooms%20%7C%20Virtual%20Offices%20%7C%20Plug%20and%20Play%20Offices!5e0!3m2!1sen!2sin!4v1768818358170!5m2!1sen!2sin";

const ReachUs = () => (
  <section className="reach-modern" id="reachus">
    <div className="reach-modern-inner">
      <div className="reach-modern-header">
        <span className="section-eyebrow">Reach Us</span>
        <h2>Visit Our Office</h2>
        <p>We are here to help your business go online. Reach out anytime.</p>
      </div>
      <div className="reach-modern-grid">
        <div className="reach-map-card">
          <iframe src={INDIA_MAP_EMBED} title="AI4Bazaar India Office" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
        </div>
        <div className="reach-info-card">
          <div className="reach-info-item">
            <FaMapMarkerAlt />
            <div>
              <strong>India Office</strong>
              <p>QHub Madhapur, 4th Floor, near Madhapur Metro Station, Madhapur, Hyderabad, Telangana 500033</p>
            </div>
          </div>
          <div className="reach-info-item">
            <FaMapMarkerAlt />
            <div>
              <strong>USA Office</strong>
              <p>8720 Silverado Trail, Suite 207, McKinney, TX 75070</p>
            </div>
          </div>
          <div className="reach-info-item">
            <FaPhone />
            <div>
              <a href="tel:+919392014678">+91 9392014678</a>
              <span> · </span>
              <a href="tel:+12015815271">+1 201-581-5271</a>
            </div>
          </div>
          <div className="reach-info-item">
            <FaEnvelope />
            <div>
              <a href="mailto:support@ai4bazaar.com">support@ai4bazaar.com</a>
            </div>
          </div>
          <Link to="/contact" className="reach-cta-btn" onClick={() => window.scrollTo(0, 0)}>
            Contact Us →
          </Link>
        </div>
      </div>
    </div>
  </section>
);

export default ReachUs;
